/**
 * @generated SignedSource<<9b68f9a60a1f31a5b027bf2d0a84e687>>
 * @relayHash 632c781b8d55ea370f4f6a4b0beb70ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cd280d0ecfd2672143be36a7d32f635bb930e71277083ab7101c2f1aa6912a8

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioSkillsQuery$variables = {
  cloudId: string;
  contextAri: string;
  isStudioCustomSkillsM1FrontendEnabled: boolean;
};
export type AgentStudioSkillsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_AtlassianAgentStudioSkills_fragmentRef" | "SkillsList_AtlassianAgentStudioSkills_fragmentRef">;
};
export type AgentStudioSkillsQuery = {
  response: AgentStudioSkillsQuery$data;
  variables: AgentStudioSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isStudioCustomSkillsM1FrontendEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Literal",
    "name": "relevantFor",
    "value": [
      "PLATFORM_SKILL"
    ]
  },
  {
    "kind": "Literal",
    "name": "surface",
    "value": "ROVO_AGENTS"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "isStudioCustomSkillsM1FrontendEnabled",
            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsFilter_AtlassianAgentStudioSkills_fragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isGraphIntegrationDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "GraphIntegrationSkillUiMetadata",
                        "kind": "LinkedField",
                        "name": "uiMetadata",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconKey"
                          }
                        ]
                      },
                      {
                        "concreteType": "GraphIntegrationSkillMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v8/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "tags"
                          },
                          {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "source"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "alias": "skillDescription",
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ],
                    "type": "GraphIntegrationSkillItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationSkillDirectoryItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "filters": [
          "cloudId",
          "relevantFor",
          "surface",
          "searchKeyword",
          "dimensionIds"
        ],
        "handle": "connection",
        "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      },
      {
        "condition": "isStudioCustomSkillsM1FrontendEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Literal",
            "name": "dimension",
            "value": "PRODUCTS"
          }
        ],
        "concreteType": "GraphIntegrationSkillDimensionMetadata",
        "kind": "LinkedField",
        "name": "graphIntegration_skillDimensionMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                  }
                ],
                "type": "GraphIntegrationSkillProductItem"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9cd280d0ecfd2672143be36a7d32f635bb930e71277083ab7101c2f1aa6912a8",
    "metadata": {},
    "name": "AgentStudioSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1f6102576d190ca076f2ebfc79876b73";

export default node;
